import React from 'react';
import { Drawer, Box, Typography, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { makeStyles } from '@material-ui/core/styles';
import NotesPanel from './NotesPanel';

const useStyles = makeStyles(() => ({
  header: {
    padding: '16px 20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    borderBottom: '1px solid #e0e0e0',
  },
}));

/**
 * Standalone drawer entry point for Notes - e.g. a "Notes" button
 * somewhere outside the Contact dialog that doesn't want the full
 * tabbed General/Enquiry/Notes experience. Same data, same behavior
 * as the dialog's Notes tab; only the chrome around NotesPanel differs.
 */
export default function ContactNotesDrawer({
  open,
  onClose,
  contact,
  notes = [],
  loading = false,
  onAddNote,
  onDeleteNote,
  currentUserId,
}) {
  const classes = useStyles();

  return (
    <Drawer anchor="right" open={open} onClose={onClose}>
      <Box display="flex" flexDirection="column" height="100%">
        <Box className={classes.header}>
          <Box>
            <Typography variant="subtitle1" style={{ fontWeight: 700 }}>
              Notes
            </Typography>
            <Typography variant="caption" color="textSecondary">
              {contact?.FullName}
            </Typography>
          </Box>
          <IconButton size="small" onClick={onClose}>
            <CloseIcon fontSize="small" />
          </IconButton>
        </Box>

        <NotesPanel
          notes={notes}
          loading={loading}
          onAddNote={onAddNote}
          onDeleteNote={onDeleteNote}
          currentUserId={currentUserId}
          variant="drawer"
        />
      </Box>
    </Drawer>
  );
}